import React, { useEffect, useState } from "react";
import type { TableProps } from "antd";
import { Button, Space, Table } from "antd";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import moment from "moment";
import { getCommonState, getRequestState } from "../../redux/store/getState";
import { RequestAtc } from "../../redux/apiSlice/requestSlice";
import modifyId from "../../utils/modifyId";
import { useNavigate } from "react-router-dom";
import useSearch from "../../hooks/useSearch";
import { getQuoteByAtc } from "../../redux/apiActions/requestsAction";
import { IconPrimary, Popup } from "../../components";
import { FaPlus } from "react-icons/fa6";
import ATCVoucherFromQuoteForm from "../../forms/ATCVoucherFromQuoteForm";
import { usePopup } from "../../hooks/usePopup";
import { QUOTE_STATUS } from "../../utils/status";
import useUser from "../../hooks/useUser";

type ColumnsType<T extends object = object> = TableProps<T>["columns"];

const ATCQuotation: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { requests, loading } = useAppSelector(getRequestState);
  const { filterFrom, filterTo } = useAppSelector(getCommonState);
  const [data, setData] = useState<RequestAtc[]>();
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const { user } = useUser();
  const [record, setRecord] = useState<any>(null);
  const popup = usePopup();
  useSearch(requests, setData);

  const isHaveEditPermission = user?.permissions?.includes("atc.edit");

  useEffect(() => {
    if (user) {
      let filter = "";
      if (filterFrom && filterTo)
        filter = `/filter?from=${filterFrom}&to=${filterTo}`;
      dispatch(getQuoteByAtc({ atc_id: user.atc.id, filter }));
    }
  }, [filterFrom, filterTo, dispatch, user]);

  const columns: ColumnsType<RequestAtc> = [
    {
      title: "Date and Time",
      dataIndex: "created_at",
      render: (created_at) =>
        `${moment(created_at).format("DD/MM/YYYY hh:mmA")}`,
    },
    {
      title: "Request ID",
      dataIndex: "id",
      render: (request_id) => <>{modifyId(request_id)}</>,
    },

    {
      title: "Exam ID",
      dataIndex: "exam",
      render: (exam) => <>{modifyId(exam.id)}</>,
    },
    {
      title: "Exam Name",
      dataIndex: "exam",
      render: (exam) => <>{exam.name}</>,
    },

    {
      title: "No. of Vouchers",
      dataIndex: "number_of_vouchers",
      render: (number_of_vouchers, record) => (
        <Button
          type="link"
          onClick={() => navigate(`/voucher-management/${record.id}`)}
          style={{ color: "white" }}
        >
          {number_of_vouchers}
        </Button>
      ),
    },
    {
      title: "Voucher Status",
      dataIndex: "status",
      render: (status) => <>{QUOTE_STATUS[status] || status}</>,
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {record.status !== "quote_requested" ? (
            <IconPrimary
              onClick={() => {
                setRecord(record);
                popup.open();
              }}
              disabled={!isHaveEditPermission}
            >
              <FaPlus color="white" />
            </IconPrimary>
          ) : null}
        </Space>
      ),
    },
  ];
  return (
    <>
      <Table
        style={{ marginTop: 20, whiteSpace: "pre" }}
        loading={loading.getRequest}
        columns={columns}
        rowKey={(record) => record.id}
        dataSource={data}
        onChange={(p) =>
          setPagination({ current: p.current || 1, pageSize: p.pageSize || 10 })
        }
        pagination={pagination}
        rowClassName={(_, index) => (index % 2 === 0 ? "tr-light" : "tr-dark")}
      />
      <Popup openTrigger={<></>} ref={popup.popupRef}>
        <ATCVoucherFromQuoteForm record={record} popup={popup} />
      </Popup>
    </>
  );
};

export default ATCQuotation;
